<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-4/usecase-01'" :width="500" :height="745" />

        </div>
        <div class="spacing center">

            <div>

                <h2>Enterprise voice services</h2>

                <p>Innovative and traditional telecommunication business services that support employee collaboration and operational functions will win new Enterprise opportunities.</p>
                <p>Traditional business-focused service examples include hosted private branch exchange (PBX) solutions, IP-centrex for multi-line hunt groups, virtual private networking (VPN), flexible call alerting, group calls and attendant services. New services developed using web/REST interfaces will provide more flexibility and programmability thanks to cloud-native architecture and open APIs.</p>
                <p>The enterprise voice services use case enables applications to seamlessly traverse voice-over long term evolution (VoLTE), voice over WiFi (VoWiFi), video communications, IP-PBXs, chatbots, contact centers, and unified communication services.</p>

                <a href="https://www.nokia.com/networks/solutions/voice-over-5g-vo5g-core/#5g-ecosystem" class="button" target="_blank">Discover the usecase</a>

            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>